import React, { useEffect, useState } from 'react';
export function FloatingParticles() {
  const [particles, setParticles] = useState<Array<{
    id: number;
    left: string;
    top: string;
    size: number;
    duration: number;
    delay: number;
  }>>([]);
  useEffect(() => {
    // Generate random particles only on client side to avoid hydration mismatch
    const newParticles = Array.from({
      length: 40
    }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      size: Math.random() * 3 + 1,
      duration: Math.random() * 20 + 10,
      delay: Math.random() * 5
    }));
    setParticles(newParticles);
  }, []);
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true" data-id="element-43">
      {particles.map(p => <div key={p.id} className="absolute rounded-full bg-blue-200/30" style={{
      left: p.left,
      top: p.top,
      width: `${p.size}px`,
      height: `${p.size}px`,
      animation: `float ${p.duration}s ease-in-out ${p.delay}s infinite alternate`
    }} data-id="element-44" />)}
      <style data-id="element-45">{`
        @keyframes float {
          0% { transform: translateY(0) translateX(0); opacity: 0.2; }
          50% { opacity: 0.8; }
          100% { transform: translateY(-100px) translateX(20px); opacity: 0.2; }
        }
      `}</style>
    </div>;
}